import styled from 'styled-components'

export const SignUpCtaWrapper = styled.div`
  height: 426px;
  color: white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  align-items: center;
  overflow: hidden;
  position: relative;

  @media only screen and (max-width: 1200px) {
    padding: 30px 5vw;
    height: 280px;
  }

  @media only screen and (max-width: 800px) {
    padding: 0;
    margin: 0;
    height: auto;
    display: ${props => (props.hideOnMobile ? 'none' : 'block')};
  }
`

export const SignUpCtaContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  @media only screen and (max-width: 1200px) {
    margin: unset;
  }

  @media only screen and (max-width: 800px) {
    flex-direction: column;
    padding-top: 35px;
    padding-bottom: 22px;
    padding-left: 22px;
    padding-right: 22px;
    box-sizing: border-box;
  }
`

export const CtaHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 1200px) {
    display: block;
  }
`

export const CtaHeaderTitle = styled.h1`
  padding: 0;
  margin: 0;
  letter-spacing: 0.01em;
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;

  @media only screen and (max-width: 1200px) {
    font-size: 24px;
  }

  @media only screen and (max-width: 600px) {
    font-size: 18px;
    line-height: 28px;
    max-width: auto;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.01em;
    color: #ffffff;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.16);
  }
`

export const CtaCheckboxList = styled.div`
  display: inline-block;
  margin-top: 32px;
  margin-bottom: 49px;

  @media only screen and (max-width: 1200px) {
    font-size: 14px;
    margin-top: 19px;
    margin-bottom: 20px;
  }

  @media only screen and (max-width: 800px) {
    font-size: 12px;
    margin-top: 26px;
    margin-bottom: 28px;
  }
`

export const QuestList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  font-weight: bold;
  cursor: pointer;

  @media only screen and (max-width: 600px) {
    white-space: nowrap;
  }
`

export const QuestCheckboxItem = styled.li`
  padding: 8px 0;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  font-size: 20px;
  margin-left: 16px;
  margin-right: 16px;
  letter-spacing: 0.01em;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  @media only screen and (max-width: 1200px) {
    display: flex;
    margin-left: 0;
  }

  @media only screen and (max-width: 800px) {
    font-size: 14px;
    line-height: 16px;
    margin-left: 0;
    padding: 5px 0;
  }

  @media only screen and (min-width: 1600px) {
    font-size: 20px;
  }
`

export const QuestCheckbox = styled.span`
  width: 24px;
  height: 24px;
  margin-right: 8px;

  @media only screen and (max-width: 1200px) {
    height: 14px;
    width: 14px;
  }
`

export const QuestTitle = styled.span`
  font-weight: bold;
  padding: 0;
  text-decoration: underline;
  color: white;
  cursor: pointer;
  outline: none;
  border: none;

  @media only screen and (max-width: 600px) {
    font-size: 12px;
    display: none;
    margin: 0;
    padding: 0;
  }
`

export const CheckboxIcon = styled.img`
  padding: 0;
  margin: 0;
  margin-right: 10px;

  @media only screen and (max-width: 1200px) {
    height: 14px;
    width: 14px;
  }
`

export const SignUpFieldWrapper = styled.div`
  width: 706px;
  height: 60px;
  background: #ffffff;
  border-radius: 71px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 800px) {
    padding: 2px 0;
    width: 100%;
    height: 39px;
  }
`

export const SignUpInput = styled.input`
  flex: 1;
  height: 100%;
  border: none;
  font-weight: 500;
  font-size: 20px;
  padding-left: 40px;
  letter-spacing: 0.01em;
  z-index: 1;
  background: transparent;

  @media (max-width: 800px) {
    width: 100%;
    height: 39px;
    font-weight: 500;
    font-size: 14px;
    line-height: 54px;
    padding-left: 20px;
  }
`

export const SignUpButton = styled.button`
  background: linear-gradient(
    270deg,
    #ff9d74 0%,
    #ff5e6d 37.4%,
    #ff4f7e 74.69%,
    #ff6d90 100%
  );
  border-radius: 37px;
  width: 186px;
  height: 100%;
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  transform: scale(1);
  transition: all 0.3s ease-in-out;
  white-space: nowrap;
  font-family: Helvetica Neue;

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)),
      linear-gradient(
        270deg,
        #ff9d74 0%,
        #ff5e6d 37.4%,
        #ff4f7e 74.69%,
        #ff6d90 100%
      );
  }

  @media only screen and (max-width: 800px) {
    width: 93px;
    height: 35px;
    margin-right: 2px;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
  }

  @media (max-width: 600px) {
    font-size: 11px;
    padding-left: 0;
    padding-right: 0;
  }
`

export const AppStoreLink = styled.a`
  position: absolute;
  bottom: 24px;
  right: 24px;
  line-height: 1;
  z-index: 2;

  & img {
    width: 133px;
  }

  @media (max-width: 1000px) {
    display: none;
  }
`
